import { NgModule } from "@angular/core";
import { FuseSharedModule } from "@fuse/shared.module";
import { NotificationsComponent } from "@app/wapps/notification/notifications.component";
import { AppRouteGuard } from "@shared/auth/auth-route-guard";
import { RouterModule } from "@angular/router";
import { CoreModule } from "@app/wapps/core/core.module";
import { CustomMaterialModule } from "@app/wapps/core/material.module";
import { FuseDirectivesModule } from "../../../@fuse/directives/directives";
import { TranslocoCoreModule } from "@i18n";
import { FlexLayoutModule } from "@angular/flex-layout";

const routes = [
    {
        path: "notification",
        component: NotificationsComponent,
        canActivate: [AppRouteGuard],
    },
    {
        path: "notification/settings",
        loadChildren: () => import("./settings/notification-settings.module").then((m) => m.NotificationSettingsModule),
    },
];

@NgModule({
    declarations: [NotificationsComponent],
    imports: [
        RouterModule.forChild(routes),
        CoreModule,
        CustomMaterialModule,
        FuseSharedModule,
        FuseDirectivesModule,

        TranslocoCoreModule,

        FlexLayoutModule,
    ],
    exports: [NotificationsComponent],
})
export class NotificationModule {
    constructor() {}
}
